const isPollingDisabled = process.env['POLLING_DISABLED'] === 'true'

const DEFAULT_REFETCH_INTERVAL_MS = 1000 * 5 // 5 seconds

export const getRefetchInterval = (
  intervalMs: number = DEFAULT_REFETCH_INTERVAL_MS,
): number | false => {
  if (isPollingDisabled) {
    return false
  }
  return intervalMs
}
